import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { NotificationService } from '../services/notification.service';

export const roleRestrictionGuard = createAuthGuard<CanActivateFn>(async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, authData: AuthGuardData) => {
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  const grantedRoles = authData.grantedRoles.realmRoles;
  const routeRoles = route.data['roleRestriction'];
  console.log('ruoli', grantedRoles)
  
  if (routeRoles.some((role: string) => grantedRoles.includes(role))) return true;

  router.navigate(['']);
  notificationService.restrictedSection();
  return false;
});
